export default __webpack_public_path__ + "static/media/florida-homes-hero-image.5e6af54d.jpg";